export default "__VITE_ASSET___CpNrKVa__"